/* eslint-disable camelcase */
import { userApi } from './index';
import { AuthCredentialsResponse, AuthCredentialsSend } from '../../../models/AuthCredentials';
import { config } from '../config';
import { TypeOfSocials } from '../../../models/Socials';

export interface SocialsProps {
  type: TypeOfSocials;
  socialUserId: string;
  email: string;
  surname?: string;
  name?: string;
  accessToken?: string;
}

interface EnterCodeSmsProps {
  auth_id: string;
  sms_code: string;
}

export const authorizationApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    combinedAuthorization: build.mutation<AuthCredentialsResponse, AuthCredentialsSend>({
      query: ({ auth_id, password }) => ({
        url: config.AUTHORIZATION.AUTH,
        method: 'POST',
        body: {
          auth_id,
          password,
        },
      }),
      invalidatesTags: [
        'UserInfo',
        'UserBanners',
        'RepairWorks',
        'Accounts',
        'RegularPayment',
        'CardList',
        'ConnectedServices',
        'Preset',
        'History',
        'MultiAccount',
      ],
    }),
    checkAuth: build.mutation<AuthCredentialsResponse, string>({
      query: (refresh_token) => ({
        url: config.AUTHORIZATION.AUTH,
        method: 'POST',
        body: {
          grant_type: 'refresh_token',
          refresh_token,
        },
      }),
    }),
    logout: build.mutation({
      query: () => ({
        url: config.AUTHORIZATION.LOGOUT,
        method: 'POST',
      }),
    }),
    requestCodeSms: build.mutation<string, string>({
      query: (auth_id) => ({
        url: config.AUTHORIZATION.AUTH,
        method: 'POST',
        body: {
          grant_type: 'sms',
          auth_id,
        },
      }),
    }),
    enterCodeSms: build.mutation<AuthCredentialsResponse, EnterCodeSmsProps>({
      query: ({ auth_id, sms_code }) => ({
        url: config.AUTHORIZATION.AUTH,
        method: 'POST',
        body: {
          grant_type: 'sms',
          auth_id,
          sms_code,
        },
      }),
      invalidatesTags: [
        'UserInfo',
        'UserBanners',
        'RepairWorks',
        'Accounts',
        'RegularPayment',
        'CardList',
        'ConnectedServices',
        'Preset',
        'History',
        'MultiAccount',
      ],
    }),
    loginWithSocial: build.mutation<AuthCredentialsResponse, SocialsProps>({
      query: ({ type, socialUserId, email, surname, name, accessToken }) => ({
        url: `${config.AUTHORIZATION.AUTH}/${type}`,
        method: 'POST',
        headers: { Socials: process.env.REACT_APP_AUTH_SOCIALS || '' },
        body: {
          social_user_id: socialUserId,
          access_token: accessToken,
          email,
          surname,
          name,
        },
      }),
      invalidatesTags: [
        'UserInfo',
        'UserBanners',
        'RepairWorks',
        'Accounts',
        'RegularPayment',
        'CardList',
        'ConnectedServices',
        'Preset',
        'History',
        'MultiAccount',
      ],
    }),
    passwordReset: build.mutation<{ success: boolean }, { authId: string }>({
      query: ({ authId }) => ({
        url: config.AUTHORIZATION.PASSWORD_RESET_V2,
        method: 'POST',
        body: {
          auth_id: authId,
        },
      }),
    }),
    confirmPasswordRecovery: build.mutation<string, { code: string; password: string }>({
      query: ({ code, password }) => ({
        url: config.AUTHORIZATION.PASSWORD_CONFIRM_V2,
        method: 'POST',
        body: {
          code,
          password,
        },
      }),
      invalidatesTags: ['MultiAccount'],
    }),
  }),
});
